import { ApiProperty } from "@nestjs/swagger";

export class GrnReturnIdRequest{
    @ApiProperty()
    grnReturnId:number;
    
 
    constructor(grnReturnId:number){
        this.grnReturnId = grnReturnId;
    }
}